import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { formatPrice } from '../../../helpers'
import StatusBadge from './StatusBadge'

const TransactionCard = ({ trx, onSelectTrx, history }) => {
  const formattedDate = new Date(trx.created_at).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })

  const ordersList = trx.orders || trx.details || trx.transaction_details || []
  const firstProduct = ordersList.length > 0 ? ordersList[0] : null
  const remainingCount = ordersList.length - 1
  const productImage = firstProduct?.product?.image || firstProduct?.image
  const productName = firstProduct?.product?.name || firstProduct?.name || `Produk #${firstProduct?.product_id || firstProduct?.id || 1}`

  const countReview = trx.count_review ?? (ordersList.length > 0 ? ordersList.filter(o => o.review != null).length : (trx.review ? 1 : 0))
  const totalOrders = ordersList.length

  return (
    <div style={{ border: '1px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px', padding: '10px 16px', backgroundColor: '#fff', marginBottom: '8px' }}>
      <div
        onClick={() => onSelectTrx(trx)}
        style={{ cursor: 'pointer' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <p className="judul" style={{ margin: 0, fontWeight: 'bold', color: '#EDB500', textTransform: 'uppercase' }}>
                {trx.code}
              </p>
              <StatusBadge status={trx.status} />
            </div>
            <span style={{ fontSize: '0.85em', color: '#777' }}>
              {formattedDate}
            </span>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p className="harga" style={{ margin: 0, fontSize: '1.1em', fontWeight: '800', color: '#fa591d' }}>
              {formatPrice(trx.total, 'Rp.')}
            </p>
          </div>
        </div>

        {firstProduct && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f5f5f5' }}>
            {productImage ? (
              <img
                src={process.env.REACT_APP_IMAGE_URL + productImage}
                alt={productName}
                style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #eee', flexShrink: 0 }}
              />
            ) : (
              <div style={{ width: '48px', height: '48px', borderRadius: '6px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#aaa', fontSize: '0.75em' }}>
                No Image
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, fontWeight: '600', color: '#333', fontSize: '0.9em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {productName}
              </p>
              <p style={{ margin: '2px 0 0 0', color: '#777', fontSize: '0.82em' }}>
                {firstProduct.quantity} x {formatPrice(firstProduct.price, 'Rp.')}
              </p>
            </div>
          </div>
        )}

        {remainingCount > 0 && (
          <div style={{ marginTop: '6px', fontSize: '0.85em', color: '#EDB500', fontWeight: '700', textAlign: 'right' }}>
            +{remainingCount} Produk lainnya
          </div>
        )}
      </div>

      {/* Section Review Button & Label */}
      {countReview < totalOrders && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
          <span style={{ fontSize: '0.85em', color: '#888' }}>
            {countReview === 0 ? 'Belum Review ?' : 'Review Belum Selesai ?'}
          </span>
          <button
            onClick={(e) => {
              e.stopPropagation()
              history.push(`/transaksi/detail/${trx.code}`)
            }}
            style={{
              padding: '4px 12px',
              fontSize: '0.82em',
              background: '#EDB500',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
              outline: 'none'
            }}
          >
            {countReview === 0 ? 'Buat Review' : 'Lanjut Review'}
          </button>
        </div>
      )}
    </div>
  )
}

export default withRouter(TransactionCard)
